import { useCallback, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Api from "../../Api";
import ClientBar from "../../parts/ClientBar";
import BoolTabs from "../../parts/BoolTabs";
import ContractHistory from "./ContractHistory";
import ContractDetails from "./ContractDetails";
import DiscreetMessage from "../../parts/DiscreetMessage";
import { RentContract, RentContractPlan } from "../../types";

const FinanceContract = () => {
  const { uuid } = useParams();
  const [contract, setContract] = useState<RentContract | null>(null);
  const [plan, setPlan] = useState<RentContractPlan | null>(null);

  const [searchParams] = useSearchParams();
  const showDetails = searchParams.get("tab") === "detalhes";

  const load = useCallback(async () => {
    return Api.financeGetContract(uuid!).then(({ contract, plan }) => {
      setContract(contract);
      setPlan(plan);
    });
  }, [uuid]);

  useEffect(() => {
    load();
  }, [load]);

  if (!contract) return <DiscreetMessage text="Carregando ..." />;

  return (
    <div>
      <ClientBar
        action="Visualizando contrato de"
        client={contract.client.name}
        url={`/financeiro/contratos/cliente/${contract.clientUuid}`}
      />

      <BoolTabs
        defaultTab={{ label: "Histórico", value: "historico" }}
        alternateTab={{ label: "Detalhes", value: "detalhes" }}
        onChange={() => {}}
      />

      {!showDetails && (
        <ContractHistory contract={contract} plan={plan!} reload={load} />
      )}

      {showDetails && <ContractDetails contract={contract} reload={load} />}
    </div>
  );
};

export default FinanceContract;
